import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing authentication on app load
    const authToken = localStorage.getItem('holyTvAuth');
    const userData = localStorage.getItem('holyTvUser');
    
    if (authToken && userData) {
      try {
        const parsedUserData = JSON.parse(userData);
        setIsAuthenticated(true);
        setUser(parsedUserData);
      } catch (error) {
        console.error('Error parsing user data from localStorage:', error);
        // Clear invalid data
        localStorage.removeItem('holyTvAuth');
        localStorage.removeItem('holyTvUser');
        setIsAuthenticated(false);
        setUser(null);
      }
    }
    
    setLoading(false);
  }, []);

  const login = (username, password) => {
    // Simple authentication logic - in production, this would be an API call
    const validCredentials = {
      admin: 'holytv2024',
      broadcaster: 'stream123',
      operator: 'live456'
    };

    if (validCredentials[username] === password) {
      const userData = { username, role: username };
      localStorage.setItem('holyTvAuth', 'authenticated');
      localStorage.setItem('holyTvUser', JSON.stringify(userData));
      setIsAuthenticated(true);
      setUser(userData);
      return { success: true };
    } else {
      return { success: false, error: 'Invalid credentials' };
    }
  };

  const logout = () => {
    localStorage.removeItem('holyTvAuth');
    localStorage.removeItem('holyTvUser');
    setIsAuthenticated(false);
    setUser(null);
  };

  const value = {
    isAuthenticated,
    user,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}; 